export default {
    data() {
        return {
            menuOpen: false,
            filterOpen: false,
            menuOpenTxt: window.Drupal.t('Menu'),
            closeTxt: window.Drupal.t('Close'),
        }
    },

    mounted() {
        window.eventBus.$on('menu-toggled', (payload) => this.menuOpen = payload);
        window.eventBus.$on('filter-toggled', (payload) => this.filterOpen = payload);
    },

    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },

        toggleFilter() {
            this.filterOpen = !this.filterOpen;
        }
    },

    watch: {
        menuOpen(newValue) {
            window.eventBus.$emit('menu-toggled', newValue);
        },

        filterOpen(newValue) {
            window.eventBus.$emit('filter-toggled', newValue);
        }
    }
}
